<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                                    :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                            </template>
                            <span>Salvar caso</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnSave" type="button" elevation="0" color="primary" dark
                                    @click="update" :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                            </template>
                            <span>Salvar caso</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnBack" type="button" elevation="0" color="primary" outlined
                                    to="/casos">Voltar</v-btn>
                            </template>
                            <span>Voltar aos casos</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="!page.isNew">
            <v-col :cols="12">
                <div class="title-container">
                    <div class="button-group">
                        <v-btn :color="dataset.tabIndex != 1 ? 'mediumGray' : 'primary'" outlined
                            @click="dataset.tabIndex = 1">
                            Detalhes
                            <v-icon right>mdi-format-list-text</v-icon>
                        </v-btn>
                        <v-btn outlined @click="dataset.tabIndex = 2"
                            :color="dataset.tabIndex != 2 ? 'mediumGray' : 'primary'">
                            Documentos
                            <v-icon right>mdi-file-document-outline</v-icon>
                        </v-btn>
                        <v-btn outlined @click="dataset.tabIndex = 3"
                            :color="dataset.tabIndex != 3 ? 'mediumGray' : 'primary'">
                            Andamento
                            <v-icon right>mdi-timeline-text-outline</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="!page.isNew && dataset.tabIndex == 1">
            <v-col cols="12">
                <v-banner outlined>
                    <v-icon slot="icon" :color="dataset.data.events_finalized_at ? 'accent' : 'warning'" size="32">
                        {{ dataset.data.events_finalized_at ? 'mdi-check-circle-outline' : 'mdi-progress-clock' }}
                    </v-icon>
                    <template v-if="dataset.data.events_finalized_at">
                        Fase de habilitações e divergências finalizada em
                        <strong>{{ dataset.data.events_finalized_at | defaultDate('DD/MM/YYYY HH:mm') }}</strong>.
                        A devedora já vê as decisões no Painel da Devedora.
                    </template>
                    <template v-else>
                        Fase de habilitações e divergências em andamento. As decisões ficam ocultas no Painel da Devedora
                        até a finalização.
                    </template>
                    <template v-slot:actions>
                        <v-btn text color="primary" :loading="finalizing" @click="toggleEventsFinalized">
                            {{ dataset.data.events_finalized_at ? 'Reabrir fase' : 'Finalizar fase' }}
                        </v-btn>
                    </template>
                </v-banner>
            </v-col>
        </v-row>

        <v-form v-if="dataset.tabIndex == 1" ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Número do Processo"
                                                v-model="dataset.data.process_number" required outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense label="Vara" v-model="dataset.data.local" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select no-data-text="Nenhuma comarca encontrada" dense
                                                :items="dataset.districts" label="Comarca"
                                                v-model="dataset.data.district_id" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-select no-data-text="Nenhuma UF encontrada" dense :items="dataset.states"
                                                label="UF" v-model="dataset.data.state" item-value="id" item-text="name"
                                                outlined :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Número de credores"
                                                v-model="dataset.data.total_creditors" required
                                                :rules="[$rules.required, $rules.number]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-currency-field label="Valor total devido" dense
                                                v-model="dataset.data.total_value" :allowNegative=false hide-details="auto"
                                                outlined required :rules="[$rules.required]">
                                            </v-currency-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CNPJ" v-model="dataset.data.registration" required
                                                v-mask="this.$masks.cnpj" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.clientTypes" label="Tipo"
                                                v-model="dataset.data.type" :rules="[$rules.required]" item-value="id"
                                                item-text="name" outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-menu v-model="dataset.menuJudgment" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense
                                                        :value="computedDateFormatted(dataset.data.judgment_at)"
                                                        label="Ajuizamento (data do pedido)" outlined readonly v-bind="attrs" v-on="on"
                                                        hide-details="auto"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dataset.data.judgment_at" no-title locale="pt-br"
                                                    @input="dataset.menuJudgment = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-menu v-model="dataset.menuDeferment" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense
                                                        :value="computedDateFormatted(dataset.data.deferment_at)"
                                                        label="Deferimento" outlined v-bind="attrs" v-on="on"
                                                        hide-details="auto"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dataset.data.deferment_at" no-title locale="pt-br"
                                                    @input="dataset.menuDeferment = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-menu v-model="dataset.menuConcession" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense
                                                        :value="computedDateFormatted(dataset.data.concession_at)"
                                                        label="Concessão" outlined readonly v-bind="attrs" v-on="on"
                                                        hide-details="auto"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dataset.data.concession_at" no-title locale="pt-br"
                                                    @input="dataset.menuConcession = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-menu v-model="dataset.menuStartEvent" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense
                                                        :value="computedDateFormatted(dataset.data.start_event_at)"
                                                        label="Início do prazo de hab/div" outlined readonly v-bind="attrs"
                                                        v-on="on" hide-details="auto"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="dataset.data.start_event_at" no-title locale="pt-br"
                                                    @input="dataset.menuStartEvent = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-menu v-model="dataset.menuEndEvent" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field dense
                                                        :value="computedDateFormatted(dataset.data.end_event_at)"
                                                        label="Fim do prazo de hab/div" outlined v-bind="attrs" v-on="on"
                                                        hide-details="auto"></v-text-field>
                                                </template>
                                                <v-date-picker :show-current="true" v-model="dataset.data.end_event_at"
                                                    locale="pt-br" no-title
                                                    @input="dataset.menuEndEvent = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(15)]"
                                                hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                                label="Banner (destaque)" :clearable="true"
                                                @change="onFileSelected('fileBanner', $event)" ref="logoFile">
                                            </v-file-input>
                                            <template v-if="dataset.data.banner_url">
                                                <v-img @click="openDoc(dataset.data.banner_url)" class="rounded-xl"
                                                    :height="100" :width="100" :src="dataset.data.banner_url"></v-img>

                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn v-on="on" class="mt-4" type="button" elevation="0"
                                                            color="primary" dark
                                                            @click="deleteFile('banner')"><v-icon>mdi-delete</v-icon>
                                                            Excluir</v-btn>
                                                    </template>
                                                    <span>Excluir banner</span>
                                                </v-tooltip>
                                            </template>
                                        </v-col>

                                        <v-col cols="6">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(15)]"
                                                hint="O arquivo não pode ser superior a 15MB" hide-details="auto"
                                                label="Logo" :clearable="true" @change="onFileSelected('fileLogo', $event)"
                                                ref="logoFile">
                                            </v-file-input>
                                            <template v-if="dataset.data.logo_url">
                                                <v-img @click="openDoc(dataset.data.logo_url)" class="rounded-xl"
                                                    :height="100" :width="100" :src="dataset.data.logo_url"></v-img>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn v-on="on" class="mt-4" type="button" elevation="0"
                                                            color="primary" dark
                                                            @click="deleteFile('logo')"><v-icon>mdi-delete</v-icon>
                                                            Excluir</v-btn>
                                                    </template>
                                                    <span>Excluir logo</span>
                                                </v-tooltip>
                                            </template>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field dense label="Site próprio do caso (opcional)"
                                                v-model="dataset.data.external_url" outlined hide-details="auto"
                                                placeholder="https://www.exemplo.com.br" prepend-inner-icon="mdi-open-in-new"
                                                :rules="[urlRule]"
                                                hint="Se preenchido, o caso no site abre este endereço em nova aba no lugar da página de detalhes."
                                                persistent-hint>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="font-weight-bold">Descrição</p>
                                            <tiptap-vuetify v-model="dataset.data.description" :extensions="extensions"
                                                hide-details="auto" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <!-- <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Credores</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum caso foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.registration`]="{ item }">
                                {{ formatCpfCnpj(item.registration) }}
                            </template>

                            <template v-slot:[`item.amount`]="{ item }">
                                R$ {{ item.amount | currency }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                {{ item.type | enum(dataset.creditorTypes, "id", "name") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-icon :disabled="!$check('users/1', ['PATCH'])" @click="viewItem(item)" size="large"
                                        class="me-2">
                                        mdi-pencil-outline
                                    </v-icon>

                                    <v-icon :disabled="!$check('users/1', ['DELETE'])" @click="deleteItem(item)"
                                        size="large" class="me-2">
                                        mdi-delete
                                    </v-icon>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <template v-if="dataset.tabIndex == 2">
            <v-row>
                <v-col cols="12">
                    <v-card class="filter-card">
                        <v-card-title class="filter-card-title">Documentos</v-card-title>
                        <v-card-text>


                            <v-row>
                                <v-col cols="12">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnFilter" @click="openAddDocumentModal(dataset.data)"
                                                color="primary" dark elevation="2">Inserir
                                            </v-btn>
                                        </template>
                                        <span>Inserir documento</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-container fluid justify-center>

                    <v-card class="elevation-1 rounded-lg my-4">
                        <v-card-title class="card-group-title mb-n3 mt-n7">Listar por:</v-card-title>
                        <v-card-text>

                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-select dense :items="availableDocTypes" no-data-text=""
                                        label="Tipo de Documento" v-model="dataset.selectedDocType" item-value="id"
                                        item-text="name" outlined @change="onChangeDocType()" hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>

                    <v-flex class="elevation-1">
                        <v-toolbar class="mb-2" color="primary" dark>
                            <v-toolbar-title>Lista de Documentos / Ordem de Apresentação</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="action('edit')" v-if="!editing" class="mr-5">
                                <v-icon>mdi-sort</v-icon>
                                Ordenar
                            </v-btn>
                            <v-btn icon @click="action('done')" v-if="editing" class="mr-10">
                                <v-icon>mdi-check</v-icon>
                                Salvar
                            </v-btn>
                            <v-btn icon @click="action('undo')" v-if="editing" class="mr-10 ml-10">
                                <v-icon>mdi-close</v-icon>
                                Desfazer
                            </v-btn>
                        </v-toolbar>
                        <v-list one-line>
                            <draggable :options="options" v-model="dataList.docsFilter">
                                <template v-for="(v, i) in dataList.docsFilter">
                                    <v-list-item :key="v.id">
                                        <v-list-item-avatar color="grey">
                                            <span style="user-select:none;">{{ i + 1 }}</span>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="v.name"></v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <div class="d-flex">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn v-on="on" icon @click="deleteDocument(v)">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Excluir documento</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }">
                                                        <v-btn v-on="on" icon @click="openEditDocumentModal(v)">
                                                            <v-icon>mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar documento</span>
                                                </v-tooltip>
                                            </div>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-list>
                    </v-flex>
                </v-container>
            </v-row>

            <client-doc-details-modal ref="clientDocDetailsModalRef"></client-doc-details-modal>

        </template>

        <client-timeline v-if="dataset.tabIndex == 3" :client-id="$route.params.id" />

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import object from "@/common/util/object"

import ClientDocDetailsModal from "@/components/ClientDocDetailsModal.vue"
import ClientTimeline from "@/components/ClientTimeline.vue"

import clientTypes from "@/common/data/client-types.data"
import creditorTypes from "@/common/data/creditor-types.data"
import { getClientDocTypes } from "@/common/data/client-doc-types.data"

import { cpf, cnpj } from 'cpf-cnpj-validator'

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'

import { eventHub } from "@/main";
import draggable from 'vuedraggable';

export default {
    name: "ClientDetails",

    components: {
        'tiptap-vuetify': TiptapVuetify,
        'client-doc-details-modal': ClientDocDetailsModal,
        'client-timeline': ClientTimeline,
        draggable,
    },

    data: () => ({
        finalizing: false,
        page: {
            isNew: false,
            title: "",
        },
        items: [
            { id: null, client_id: null, order: null }
        ],
        editing: false,
        before: null,
        dataset: {
            clientTypes: clientTypes,
            creditorTypes: creditorTypes,
            breadcrumbItems: [],
            states: states,
            data: {
                judgment_at: null,
                deferment_at: null,
                concession_at: null,
                end_event_at: null,
                start_event_at: null
            },
            districts: [],
            menuJudgment: false,
            menuDeferment: false,
            menuConcession: false,
            menuStartEvent: false,
            menuEndEvent: false,
            selectedDocType: null,
            tabIndex: 1,
        },
        selectedDoc: null,
        dialogViewDoc: false,
        dialogDocDetails: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],

        dataList: {
            filter: {
                name: "",
                status: "",
                type: "",
                district: ""
            },
            docsFilter: [],

            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Valor", value: "amount" },
                { text: "Classe", value: "type" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
            }
        },
    }),

    created() {
        this.loadData()

        eventHub.$on('DIALOG-CLIENT-DOC-DETAILS', value => {
            this.dialogDocDetails = value;
        });
    },

    computed: {
        availableDocTypes() {
            return getClientDocTypes(this.dataset.data && this.dataset.data.type);
        },
        options() {
            return {
                disabled: !this.editing
            }
        }
    },

    methods: {
        urlRule(value) {
            const url = (value || '').trim();
            if (!url) return true;
            return /^(https?:\/\/)?[^\s/.]+\.[^\s]+$/i.test(url) || 'Informe um endereço válido (ex.: https://www.exemplo.com.br)';
        },

        computedDateFormatted(date) {
            return date && date !== "0000-00-00 00:00:00" ? this.$moment(date).format('DD/MM/YYYY') : null
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        goBack() {
            this.$router.replace("/casos");
        },

        openDoc(doc) {
            this.selectedDoc = doc;
            this.dialogViewDoc = true;
        },

        pageChanged(page) {
            console.log('page changed ', page)
            this.dataList.options.page = page;
            this.loadCreditors();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.loadCreditors();
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.loadDistricts()
            await this.load();

            await this.loadCreditors();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? `Novo caso` : `Detalhes do caso`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Início",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de casos",
                disabled: false,
                to: "/casos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes do caso`,
                disabled: true,
                exact: true,
            });
        },

        // Lista os documentos do tipo escolhido (qualquer categoria: Relação de Credores, QGC, Editais...).
        onChangeDocType() {
            const type = Number(this.dataset.selectedDocType);

            this.dataList.docsFilter = type
                ? (this.dataset.data.documents || [])
                    .filter(item => Number(item.type) === type)
                    .sort((a, b) => a.order - b.order)
                : [];
        },

        action(e) {
            switch (e) {
                case 'edit':
                    this.before = Object.assign([], this.dataList.docsFilter);
                    break;
                case 'undo':
                    this.dataList.docsFilter = this.before;
                    break;
                case 'done':
                    this.saveDocumentOrder()
                    break;
                default:
                    break;
            }

            this.editing = !this.editing
        },

        async saveDocumentOrder() {

            const data = this.dataList.docsFilter.map(item => ({
                id: item.id,
                client_id: item.client_id,
                order: item.order
            }))

            data.forEach((item, index) => {
                item.order = index + 1;
            });

            try {

                const response = await axios.patch(`/api/admin/client-docs/order/${data[0].client_id}`, { list: data });

                this.$dialog.notify.info("Nova ordenação salva com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

        openEditDocumentModal(item) {

            this.$refs.clientDocDetailsModalRef.setData(this.dataset.data, item);

            this.$refs.clientDocDetailsModalRef.open().then(async (results) => {
                await this.load();
                this.onChangeDocType();
            });
        },

        async deleteDocument(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/client-docs/${item.id}`)

                this.$dialog.notify.info("Documento excluído com sucesso!", { position: "top-right", timeout: 2000 });

                await this.load()

                this.onChangeDocType()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }
        },

        buildPayloadDocument() {

            const lastValue = this.items.reduce((max, obj) => (obj.order > max ? obj.order : max), -Infinity);

            const data = {
                order: isFinite(lastValue) ? lastValue + 1 : 1,
                client: this.dataset.data.client_id
            }

            return data;
        },

        async openAddDocumentModal(item) {

            this.$refs.clientDocDetailsModalRef.setData(item);

            this.$refs.clientDocDetailsModalRef.open().then(async (results) => {
                await this.load();
                this.onChangeDocType();
            });
        },

        async toggleEventsFinalized() {
            const finalize = !this.dataset.data.events_finalized_at;

            const confirmed = await this.$dialog.confirm({
                title: finalize ? 'Finalizar fase de Hab/Div' : 'Reabrir fase de Hab/Div',
                text: finalize
                    ? 'A devedora passará a ver no Painel da Devedora a decisão de cada habilitação e divergência deste caso. Deseja finalizar?'
                    : 'As decisões voltarão a ficar ocultas no Painel da Devedora. Deseja reabrir?',
                actions: { false: 'Cancelar', true: finalize ? 'Finalizar' : 'Reabrir' },
            });
            if (!confirmed) return;

            this.finalizing = true;

            try {
                const result = await axios.post(`/api/admin/clients/${this.$route.params.id}/events-finalized`, { finalized: finalize });
                this.$set(this.dataset.data, 'events_finalized_at', result.data.content.events_finalized_at);
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.finalizing = false;
            }
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/clients/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    judgment_at: data.judgment_at !== '0000-00-00 00:00:00' ? data.judgment_at : null,
                    deferment_at: data.deferment_at !== '0000-00-00 00:00:00' ? data.deferment_at : null,
                    concession_at: data.concession_at && data.concession_at !== '0000-00-00 00:00:00' ? data.concession_at : null,
                    start_event_at: data.start_event_at !== '0000-00-00 00:00:00' ? data.start_event_at : null,
                    end_event_at: data.end_event_at !== '0000-00-00 00:00:00' ? data.end_event_at : null,
                };

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadCreditors() {

            if (this.page.isNew) return;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
            var page = this.dataList.options.page;

            try {
                const result = await axios.get(`/api/clients/creditors/${this.$route.params.id}`, { params: { page, limit, search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadDistricts() {

            try {
                const result = await axios.get(`/api/districts`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.districts = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o caso?',
                title: 'Incluir caso',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/clients', payload);

                this.$dialog.notify.info("Caso salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o caso?',
                title: 'Atualizar caso',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/admin/clients/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Cliente salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async deleteFile(file) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir arquivo',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            try {

                const result = await axios.delete(`/api/admin/clients/${this.$route.params.id}/file/${file}`)

                this.$dialog.notify.info("Arquivo excluído com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            }

        },

        onFileSelected(field, file) {
            this.dataset.data[field] = file;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.description)
                formData.append('description', this.dataset.data.description);

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.local)
                formData.append('local', this.dataset.data.local);

            if (this.dataset.data.state)
                formData.append('state', this.dataset.data.state);

            if (this.dataset.data.process_number)
                formData.append('process_number', this.dataset.data.process_number);

            if (this.dataset.data.total_creditors)
                formData.append('total_creditors', this.dataset.data.total_creditors);

            if (this.dataset.data.total_value)
                formData.append('total_value', this.dataset.data.total_value);

            if (this.dataset.data.registration)
                formData.append('registration', this.dataset.data.registration);

            if (this.dataset.data.type)
                formData.append('type', this.dataset.data.type);

            if (this.dataset.data.start_event_at)
                formData.append('start_event_at', this.dataset.data.start_event_at);

            if (this.dataset.data.end_event_at)
                formData.append('end_event_at', this.dataset.data.end_event_at);

            if (this.dataset.data.judgment_at)
                formData.append('judgment_at', this.dataset.data.judgment_at);

            if (this.dataset.data.deferment_at)
                formData.append('deferment_at', this.dataset.data.deferment_at);
            if (this.dataset.data.concession_at)
                formData.append('concession_at', this.dataset.data.concession_at);

            if (this.dataset.data.district_id)
                formData.append('district_id', this.dataset.data.district_id);

            // sempre enviado: vazio remove o site próprio
            formData.append('external_url', (this.dataset.data.external_url || '').trim());

            if (this.dataset.data.fileLogo)
                formData.append('files[]', this.dataset.data.fileLogo, 'logo')

            if (this.dataset.data.fileBanner)
                formData.append('files[]', this.dataset.data.fileBanner, 'banner')

            return formData;
        },




    },
};
</script>
  
<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.checkbox-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
</style>